import Vue from 'vue'
import { isOnlyWechat, isOnlyWeCom, isFeishu, isDingding } from '@/lib/ui/utils/platform.util.js'
// 微信定位
import { wxGetLocation } from '../wx-sdk'
import { weComGetLocation } from '../we-com-sdk'
import { feishuGetLocation } from '../feishu-sdk'
import { dingdingGetLocation } from '../dingding-sdk'

/**
 * 根据不同浏览器获取地理位置
 * 可以在任何文件直接调用 getLocation 方法获取当前位置的经纬度
 * @param showMessage 是否展示message
 */
export function getLocation(showMessage) {
  return new Promise((resolve, reject) => {
    if (isOnlyWechat()) {
      // 微信浏览器使用微信定位
      Vue.prototype.$bus.$on(`getLocationEvent`, () => {
        wxGetLocation(showMessage, (result) => {
          if (result) {
            resolve(result)
          } else {
            reject(new Error())
          }
        })
        Vue.prototype.$bus.$off('getLocationEvent')
      })
    } else if (isOnlyWeCom() && Vue.prototype.$weComConfigStatus === true) {
      // window.wx.ready((res) => {
      Vue.prototype.$weComConfigStatus = true
      // 企业微信浏览器使用微信定位
      Vue.prototype.$bus.$on(`getLocationEvent`, () => {
        weComGetLocation(showMessage, (result) => {
          if (result) {
            resolve(result)
          } else {
            reject(new Error())
          }
        })
        Vue.prototype.$bus.$off('getLocationEvent')
      })
    } else if (isFeishu()) {
      feishuGetLocation(showMessage, (result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else if (isDingding()) {
      dingdingGetLocation(showMessage, (result) => {
        if (result) {
          resolve(result)
        } else {
          reject(new Error())
        }
      })
    } else {
      // 其他情况使用高德地图定位
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        showMarker: false,
        showCircle: false,
        panToLocation: false
      })
      geolocation.getCurrentPosition((status, result) => {
        if (status === 'complete' && result && result.position) {
          resolve(result.position)
        } else {
          if (showMessage) {
            Vue.prototype.$message({
              type: 'error',
              message: `没有定位权限，请稍后重试`
            })
          }
          reject(new Error())
        }
      })
    }
  })
}
